import {
  matchesBalanceSheetKeywords,
  normaliseBalanceSheetName,
} from "./budgetEditorBalanceSheetKeywords";
import { ItemType } from "./itemTypes";

const GAIN_LOSS = "(?:gains?|loss(?:es)?|profits?)";
const DISPOSAL = "(?:sale|disposal|disposals|disposition)";
const ASSET_WORDS = "(?:(?:fixed |capital |non current )?assets? )?";

/** "Gain on sale of assets", "Gain/(Loss) on disposal", "Profit or loss from sale". */
const GAIN_LOSS_ON_SALE = new RegExp(
  `\\b${GAIN_LOSS}(?:(?: or| and)? ${GAIN_LOSS})? (?:on|from|of|in) (?:the )?${ASSET_WORDS}${DISPOSAL}\\b`,
);
/** "Sale of assets - gain", "Disposal of fixed assets (loss)". */
const SALE_OF_ASSETS_GAIN_LOSS = new RegExp(
  `\\b${DISPOSAL} of (?:fixed |capital )?assets? ${GAIN_LOSS}\\b`,
);

const STOCK_SALE_KEYWORDS = ["stock", "inventory", "goods", "products"];

/**
 * True for a Profit and Loss account that records the gain or loss when an
 * asset is sold (for example "Gain on Sale of Assets", "Loss on Disposal of
 * Fixed Assets"). The sale itself is budgeted on the asset's own balance sheet
 * row, so these accounts get no budget and no AI suggestion: counting both
 * would count the sale twice. Balance sheet accounts are never matched.
 */
export const isGainOrLossOnAssetSaleAccount = (
  name: string | null | undefined,
  itemType: ItemType,
): boolean => {
  if (itemType !== ItemType.revenue && itemType !== ItemType.expense) {
    return false;
  }
  const normalised = normaliseBalanceSheetName(name);
  if (!normalised) return false;
  if (matchesBalanceSheetKeywords(STOCK_SALE_KEYWORDS, normalised))
    return false;
  return (
    GAIN_LOSS_ON_SALE.test(normalised) ||
    SALE_OF_ASSETS_GAIN_LOSS.test(normalised)
  );
};
